/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { selectAvatarPath } from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import { childCommentsReduceName } from 'mt-react-common/modules/comments/reducers/list/reducer';
import {
  initState,
  sendForm,
  setFieldContent,
  setFieldLike,
  setFieldModelClass,
  setFieldModelId,
  setFieldParentId
} from 'mt-react-common/modules/comments/reducers/form/actions';
import {
  hasFieldError,
  selectFirstErrorByFiled
} from 'mt-react-common/common/reducers/_formErrors/reducer';
import { addItemToDown } from 'mt-react-common/common/reducers/__childMultipleList/reducer';
import { selectRequestStatusData } from 'mt-react-common/common/reducers/_requestStatus/reducer';
import { connect } from 'react-redux';
import { selectResultObject } from 'mt-react-common/modules/comments/reducers/form/selectors';

class CommentChildForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        like: 0
      }
    };
  }

  componentDidMount() {
    this.props.initState();
    this.props.setFieldModelClass(this.props.modelClass);
    this.props.setFieldModelId(this.props.modelId);
    this.props.setFieldParentId(this.props.parentId);
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextState.form.like !== this.state.form.like) {
      this.props.setFieldLike(nextState.form.like);
    }
    if (
      nextProps.requestStatusData.codeResponse !==
        this.props.requestStatusData.codeResponse &&
      nextProps.requestStatusData.codeResponse === 201 &&
      this.props.selectResultObject
    ) {
      console.log(nextProps.selectResultObject);
      this.props.addItemToDown({
        itemId: nextProps.selectResultObject.id,
        parentId: nextProps.selectResultObject.parentId,
        item: nextProps.selectResultObject
      });
      this.props.hideSubForm();
    }
  }

  handleChangeField = async event => {
    switch (event.target.name) {
      case 'content':
        this.props.setFieldContent(event.target.value);
        break;
      default:
        break;
    }
  };

  handleChangeLikeField = value => {
    if (value !== this.state.form.like) {
      this.setState({ form: { like: value } });
    } else {
      this.setState({ form: { like: 0 } });
    }
  };

  render() {
    const errorDesc = fieldName => {
      if (this.props.hasFieldError(fieldName)) {
        return (
          <small className="help-block">
            {this.props.selectFirstErrorByFiled(fieldName).message}
          </small>
        );
      }
      return null;
    };
    return (
      <div className="media media_comment media_comment_default media_table">
        <div className="media-left avatar-sm">
          <img
            alt=""
            className="media-object avatar avatar-sm"
            src={this.props.avatarPath}
          />
        </div>
        <div className="media-body">
          <form>
            <div
              className={`form-group ${
                this.props.hasFieldError('content') ? 'has-error' : ''
              }`}
            >
              <textarea
                onChange={this.handleChangeField}
                name="content"
                className="form-control"
                rows="3"
                placeholder="Ваше слово"
              />
              {errorDesc('content')}
            </div>
            <div className="btn-toolbar">
              <button
                type="button"
                className="btn btn-primary pull-right"
                onClick={() => this.props.sendForm()}
              >
                Отправить
              </button>
              <div className="btn-group pull-right" data-toggle="buttons">
                <label
                  onClick={() => this.handleChangeLikeField(1)}
                  htmlFor="option1"
                  className={`btn btn-muted ${
                    this.state.form.like === 1 ? 'active' : ''
                  }`}
                >
                  <i className="fa fa-thumbs-o-up" />
                </label>
                <label
                  onClick={() => this.handleChangeLikeField(-1)}
                  htmlFor="option2"
                  className={`btn btn-muted ${
                    this.state.form.like === -1 ? 'active' : ''
                  }`}
                >
                  <i className="fa fa-thumbs-o-down" />
                </label>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

CommentChildForm.propTypes = {
  modelClass: PropTypes.number.isRequired,
  modelId: PropTypes.number.isRequired,
  parentId: PropTypes.number.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  reducerName: PropTypes.string.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  listReducerName: PropTypes.string.isRequired,
  hideSubForm: PropTypes.func.isRequired,

  initState: PropTypes.func.isRequired,
  setFieldModelClass: PropTypes.func.isRequired,
  setFieldModelId: PropTypes.func.isRequired,
  setFieldParentId: PropTypes.func.isRequired,
  setFieldContent: PropTypes.func.isRequired,
  setFieldLike: PropTypes.func.isRequired,
  sendForm: PropTypes.func.isRequired,
  addItemToDown: PropTypes.func.isRequired,

  avatarPath: PropTypes.string.isRequired,
  requestStatusData: PropTypes.shape({
    requestInProcess: PropTypes.bool,
    codeResponse: PropTypes.number
  }).isRequired,
  hasFieldError: PropTypes.func.isRequired,
  selectFirstErrorByFiled: PropTypes.func.isRequired,
  selectResultObject: PropTypes.shape({
    id: PropTypes.number,
    parentId: PropTypes.number
  }).isRequired
};

const mapStateToProps = (state, props) => ({
  avatarPath: selectAvatarPath(state),
  requestStatusData: selectRequestStatusData(props.reducerName, state),
  hasFieldError: fieldName =>
    hasFieldError(state, props.reducerName, fieldName),
  selectFirstErrorByFiled: fieldName =>
    selectFirstErrorByFiled(state, props.reducerName, fieldName),
  selectResultObject: selectResultObject(state, props.reducerName)
});

const mapDispatchToProps = (dispatch, props) => ({
  initState: () => dispatch(initState(props.reducerName)),
  setFieldModelClass: value =>
    dispatch(setFieldModelClass(props.reducerName, value)),
  setFieldModelId: value => dispatch(setFieldModelId(props.reducerName, value)),
  setFieldParentId: value =>
    dispatch(setFieldParentId(props.reducerName, value)),
  setFieldContent: value => dispatch(setFieldContent(props.reducerName, value)),
  setFieldLike: value => dispatch(setFieldLike(props.reducerName, value)),
  sendForm: () => dispatch(sendForm(props.reducerName)),
  addItemToDown: payload =>
    dispatch(
      addItemToDown(props.listReducerName, childCommentsReduceName, payload)
    )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommentChildForm);



// WEBPACK FOOTER //
// ./src/components/Comment/CommentChildForm/CommentChildForm.js